module.exports = __webpack_public_path__ + "img/reagentBack.cd0e397b.png";